import merge from 'lodash/merge';

import ru from './ru.yaml';
import en from './en.yaml';

export default merge(ru, en);
